import { Component } from "~/ecs/base"
import { FaceMapColors2 } from "./FaceMapColors2"

export class FaceMapColorsActive extends Component {
  static activator = FaceMapColors2
}
